import { useLocation } from 'react-router-dom';

export const useActiveNavLink = (route) => {
  route = route.split('?')[0];

  const { pathname } = useLocation(route) || {};

  return pathname === route;
};
